export const skipped = Symbol("---unvisited---")
